export default "__VITE_ASSET__BkI5EwW6__"